// Version : 1.0.0
// Author : AGALYA
import BasicDetailsActionType from './basic-details.types';

/** ***************** BASIC DETAILS ADD START *********************** */
export const basicDetailsAddStart = (basicDetailsCredentials: any) => ({
	type: BasicDetailsActionType.BASIC_DETAILS_ADD_START,
	payload: basicDetailsCredentials,
});

export const basicDetailsAddSuccess = (basicDetailsSuccess: any) => ({
	type: BasicDetailsActionType.BASIC_DETAILS_ADD_SUCCESS,
	payload: basicDetailsSuccess,
});

export const basicDetailsAddFailure = (basicDetailsFailure: unknown) => ({
	type: BasicDetailsActionType.BASIC_DETAILS_ADD_FAILURE,
	payload: basicDetailsFailure,
});

export const basicDetailsAddResponseResetStart = () => ({
	type: BasicDetailsActionType.BASIC_DETAILS_ADD_RESPONSE_REST_START,
});

export const basicDetailsAddUserResponseChanged = () => ({
	type: BasicDetailsActionType.BASIC_DETAILS_ADD_RESPONSE_CHANGED,
});
/** ***************** BASIC DETAILS ADD END *********************** */
